import React, { Component } from "react";
import logo from "../../images/confia-logo.svg";

class CompanyLogo extends Component {
  constructor(props) {
    super(props);
    this.state = { logoSrc: logo };
  }
  componentDidMount() {
    if (this.props.logo) {
      this.setState({ logoSrc: this.props.logo });
    }
  }
  render() {
    return (
      <>
        <img src={this.state.logoSrc} alt="" className="img-fluid mx-auto d-block mt-4 mb-4" style={{ objectFit: "contain", maxHeight: "90px" }} />
      </>
    );
  }
}

export default CompanyLogo;
